<template>
    <BaseSection class="quicklinks-section section--wide">
        <template #title>
            <slot name="title" />
        </template>

        <BaseQuicklinkList
            v-for="(list, index) in lists"
            :key="index"
            :links="list.links"
            :title="list.title"
        />
    </BaseSection>
</template>

<script>
export default {
    props: {
        lists: {
            type: Array,
            required: true,
            default: () => []
        }
    }
};
</script>

<style lang="less">
.quicklinks-section {
    .section__content {
        display: grid;
        grid-template-columns: 1fr;
        gap: var(--spacing-lg);

        @media @q-xs-min {
            grid-template-columns: repeat(auto-fill, minmax(18.5rem, 1fr));
        }

        @media @q-lg-min {
            grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));
            gap: var(--spacing-xl);
        }
    }
}
</style>
